module.exports = __webpack_public_path__ + "static/media/InterviewModeSelfQuestion.8293bb6c.svg";